<isophi-app-portfolio-plan-base-item
  #base
  *transloco="let t"
  [leftIcon]="'linear_scale'"
  [rightIcon]="'add_2'"
  [title]="t('planDetail/linkedTargets')"
  [allowEditMode]="allowEditMode"
  (modeChange)="handleModeChanged($event)"
>
  <div *ngIf="base.isViewMode() && teacherActivityTargetLinks.length > 0" class="d-flex flex-column gap-2">
    <ng-container *ngIf="!loadingTeacherActivityTargetLinks; else loading">
      <ng-container *ngFor="let link of teacherActivityTargetLinks">
        <ng-template #linkContent>
          <div class="title">{{ link.target.title }}</div>
          <div class="flex-1 text-sm-center text-start">
            <span class="target-state"
                  [ngClass]="getTargetStateClass(link.target.state)">{{ targetStateData[link.target.state] }}</span>
          </div>
          <div class="date flex-1 text-center">{{ link.target.fulfillmentDate | date : 'd. M. y' }}</div>
          <span class="close-icon">
          <span *ngIf="allowEditMode" class="material-symbols-rounded" (click)="handleLinkDelete(link.id, $event)">close</span>
            </span>
        </ng-template>
        <a *ngIf="useAbsoluteHref" [attr.href]="buildTeacherTargetRouteLink(link.target.id)" target="_blank" class="link-item">
          <ng-container *ngTemplateOutlet="linkContent"></ng-container>
        </a>
        <a *ngIf="!useAbsoluteHref" [routerLink]="buildTeacherTargetRouteLink(link.target.id)" class="link-item">
          <ng-container *ngTemplateOutlet="linkContent"></ng-container>
        </a>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="allowEditMode && base.isEditMode()" class="d-flex flex-column">
    <ng-container *ngIf="!loadingTeacherTargets; else loading">
      <ng-container *ngIf="teacherTargets.length > 0; else noTargets">
        <div class="link-select-item" *ngFor="let target of teacherTargets">
          <div class="d-flex align-items-center gap-3 w-sm-auto checkbox-wrapper">
            <div class="form-check w-auto">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="selectedTargetUuids.includes(target.id)"
                (change)="handleTeacherTargetSelect($event, target.id)"
              />
            </div>
            <div class="title">{{ target.title }}</div>
          </div>
          <div class="target-state" [ngClass]="getTargetStateClass(target.state)">
            {{ targetStateData[target.state] }}
          </div>
          <div class="date flex-1">{{ target.fulfillmentDate | date : 'd. M. y' }}</div>
        </div>
      </ng-container>
      <ng-template #noTargets>
        <div>{{ t("Toto pole vyplňujte pouze ve chvílí, kdy máte zadané v rámci plánu cíle aktivity.") }}</div>
      </ng-template>
    </ng-container>
  </div>
  <ng-template #loading>
    <div class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-template>
  <div *ngIf="allowEditMode && base.isEditMode()" class="actions d-flex justify-content-end mt-4">
    <button (click)="base.setMode(base.modeEnum.VIEW)" class="btn btn-light-outline">
      {{ t('common/cancel') }}
    </button>

    <button (click)="save(); base.setMode(base.modeEnum.VIEW)" class="btn btn-primary">
      {{ t('common/save') }}
    </button>
  </div>
</isophi-app-portfolio-plan-base-item>
